import React from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-semibold text-gray-200 mb-2">
            {label}
          </label>
        )}
        <input
          ref={ref}
          className={cn(
            // Base styles - larger touch target (min-h-12 = 48px)
            'w-full px-4 py-3 min-h-[48px] bg-dark-lighter border-2 border-gray-700/50 rounded-xl shadow-sm',
            // Text styling
            'text-white text-base placeholder-gray-500',
            // Focus states - prominent gold ring
            'focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-200',
            // Disabled state
            'disabled:bg-dark-card disabled:cursor-not-allowed disabled:opacity-50',
            // Error state
            error && 'border-error/50 focus:ring-error/50 focus:border-error',
            className
          )}
          {...props}
        />
        {hint && !error && (
          <p className="mt-1.5 text-xs text-gray-500">{hint}</p>
        )}
        {error && (
          <p className="mt-1.5 text-sm text-error flex items-center gap-1">
            <span>⚠️</span> {error}
          </p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
